export default __webpack_public_path__ + "static/media/task_appointment_confirmed_icon.c4e2441d.svg";